// Хотя по идее он должен называться axios,а не api.
import axios from '@/utils/api';

const getSelectLayer = (
  id,
) => axios.get(`admin/layer-objects/${id}`).then(res => res);

const getValueList = (
  id,
) => axios.get(`admin/layer-objects/${id}/valueList`).then(res => res.data);

const saveLayerSettings = (
  id,
  settings,
) => axios.put(`admin/layer-objects/${id}/settings`, { settings });

const deleteLayerAttachment = (
  layerId,
  id,
) => axios.delete(`admin/layer-objects/${layerId}/attachment/${id}`);

const saveOrUpdateRegionPresetValues = (
  layerId,
  data,
) => axios.put(`admin/layer-objects/${layerId}/valueList`, data);

const getPermissionsList = () => axios.get('/layer-objects/action-permissions');


/* eslint-disable */
export {
  getSelectLayer,
  getValueList,
  saveLayerSettings,
  deleteLayerAttachment,
  saveOrUpdateRegionPresetValues,
  getPermissionsList,
};
